import { useTranslation } from 'react-i18next';

import { NCCard, NCCard2SectionLayout, NCCardHeader } from '@/components/NCCard/NCCard';

import { GraphTile } from './components/GraphTile';
import { StatsTile } from './components/StatsTile';

export const NdviCard = () => {
  const { t } = useTranslation();

  return (
    <NCCard>
      <NCCardHeader title={t('shared.ncaDetail.details.landMonitoring.ndvi.evolution.title')} />
      <NCCard2SectionLayout className='[&>*]:py-8'>
        <GraphTile />
        <StatsTile />
      </NCCard2SectionLayout>
    </NCCard>
  );
};
